export default __webpack_public_path__ + "static/media/svg3.55138752.svg";